<select id="url-component-select" name="d" [(ngModel)]="url">
	<option value="www.royalcaribbean.com">www.royalcaribbean.com</option>
	<option value="www.royalcaribbean.es" selected>www.royalcaribbean.es</option>
	<option value="www.royalcaribbean.com.br">www.royalcaribbean.com.br</option>
	<option value="www.royalcaribbean.com.au">www.royalcaribbean.com.au</option>
	<option value="www.royalcaribbean-espanol.com">www.royalcaribbean-espanol.com</option>
	<option value="www.test1.royalcaribbean.com">www.test1.royalcaribbean.com</option>
	<option value="www.test1.royalcaribbean.es" selected>www.test1.royalcaribbean.es</option>
	<option value="www.test1.royalcaribbean.com.br">www.test1.royalcaribbean.com.br</option>
	<option value="www.test1.royalcaribbean.com.au">www.test1.royalcaribbean.com.au</option>
	<option value="www.test1.royalcaribbean-espanol.com">www.test1.royalcaribbean-espanol.com</option>
	<option value="www.royalcaribbean.com.dk">www.royalcaribbean.com.dk</option>
	<option value="www.stage2.royalcaribbean.com">www.stage2.royalcaribbean.com</option>
	<option value="www.stage2.royalcaribbean.es">www.stage2.royalcaribbean.es</option>
	<option value="www.stage2.royalcaribbean.com.br">www.stage2.royalcaribbean.com.br</option>
	<option value="www.stage2.royalcaribbean.com.au">www.stage2.royalcaribbean.com.au</option>
	<option value="www.stage2.royalcaribbean-espanol.com">www.stage2.royalcaribbean-espanol.com</option>
</select>

<h4 id="url-component-title">{{ url }}</h4>

<ul id="url-component-list">
	<li id="url-component-list__li-about">
		<a id="url-component-list__li-about-link" target="blank" href="{{ urlService.aboutUs(url) }}">About Us</a>
	</li>
	<li id="url-component-list__li-contact-us">
		<a id="url-component-list__li-contact-us-link" target="blank" href="{{ urlService.contactUs(url) }}">Contact Us</a>
	</li>
	<li id="url-component-list__li-privacy">
		<a id="url-component-list__li-privacy-link" target="blank" href="{{ urlService.privacyPolicy(url) }}">Policy</a>
	</li>
	<li id="url-component-list__li-legal">
		<a id="url-component-list__li-legal-link" target="blank" href="{{ urlService.legal(url) }}">Legal</a>
	</li>
	<li id="url-component-list__li-site-map">
		<a id="url-component-list__li-site-map-link" target="blank" href="{{ urlService.siteMap(url) }}">Site Map</a>
	</li>
	<li id="url-component-list__li-cuba-affidavit">
		<a id="url-component-list__li-cuba-affidavit-link" target="blank" href="{{ urlService.cubaAffidavitLink(url) }}">Cuba Affidavit</a>
	</li>
	<li id="url-component-list__li-faq">
		<button id="url-component-list__li-faq-get-link" (click)="getFaq()">
			Faq
		</button>
	</li>
</ul>
